// Keep stored titles and matching unchanged; cards put the distinguishing name first.
export function taskVariantLabels(template = {}) {
  const variantName = String(template.variantName || "").trim()
  const group = String(template.variantGroupTitle || template.variantParentTitle || "").trim()
  const isVariant = template.isGroupedVariant || template.parentTemplateId || template.variantsConfigured
  return isVariant && !template.isVariantGroup && variantName && variantName !== "Standard" && group && variantName !== group
    ? { title: variantName, group }
    : { title: template.title || "", group: "" }
}

export function buildTaskVariantGroups(templates = []) {
  const groups = new Map()
  const amtli = templates.filter((template) => template.category === "ämtli" || (!template.category && template.type === "task"))
  for (const template of amtli) {
    const id = String(template.variantGroupId || template.parentTemplateId || template._id || template.id)
    if (!groups.has(id)) {
      const root = amtli.find((candidate) => String(candidate._id || candidate.id) === id)
      groups.set(id, {
        id, root: root || template,
        title: template.variantGroupTitle || template.variantParentTitle || template.title,
        color: (root || template).color, icon: (root || template).icon,
        supportsVariants: (root || template).supportsVariants === true,
        variants: [],
      })
    }
    if (!template.isVariantGroup && (!template.isGroupedVariant || template.groupMember)) groups.get(id).variants.push(template)
  }
  return [...groups.values()]
    .filter((group) => group.variants.some((template) => template.enabledInStudio || template.groupMember || template.variantsConfigured || template.parentTemplateId))
    .map((group) => ({
      ...group,
      variants: group.variants.sort((a, b) => Number(Boolean(a.parentTemplateId)) - Number(Boolean(b.parentTemplateId)) ||
        String(a.variantName || a.title).localeCompare(String(b.variantName || b.title), "de-CH")),
    }))
    .sort((a, b) => a.title.localeCompare(b.title, "de-CH"))
}

export function taskMatchesTemplate(item, template) {
  const templateId = item.rawData?.templateId || item.templateId
  if (templateId) return String(templateId) === String(template._id || template.id)
  if (template.isGroupedVariant) return (template.legacyTemplateTitles || []).includes(item.title) || item.title === template.title
  return !template.parentTemplateId && (item.title === template.title || (template.variantGroupTitle && item.title === template.variantGroupTitle))
}

// This is a configuration preview, not the allocation result. Flexible rules
// mark candidate days explicitly; they do not promise work on every such day.
export function taskVariantWeek(variants, referenceDate) {
  const start = new Date(`${String(referenceDate).slice(0, 10)}T12:00:00Z`)
  if (!Number.isFinite(start.getTime())) return []
  start.setUTCDate(start.getUTCDate() - ((start.getUTCDay() + 6) % 7))
  return ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"].map((label, index) => {
    const date = new Date(start)
    date.setUTCDate(start.getUTCDate() + index)
    const entries = []
    for (const variant of variants) {
      if (!variant.enabledInStudio || variant.frequency === "once") continue
      if (variant.weekendConfig?.mode === "skip_weekend" && index > 4) continue
      const config = variant.frequencyConfig || {}
      const days = variant.frequency === "weekly" ? config.daysOfWeek || [] : config.daysOfMonth || []
      const dayValue = variant.frequency === "weekly" ? index + 1 : date.getUTCDate()
      if (variant.frequency !== "daily" && days.length && !days.map(Number).includes(dayValue)) continue
      const flexible = variant.frequency !== "daily" && (!days.length || config.daySelectionMode === "one")
      entries.push({ id: String(variant._id || variant.id), name: variant.variantName || "Standard", flexible })
    }
    return { label, date: date.toISOString().slice(0, 10), day: date.getUTCDate(), entries }
  })
}
